import { logger } from "../../../../../constant/winston";

export const getVisibility = (component: any, condition: string | undefined) => {
  let visibility = true;
  if (condition) {
    try {
      // eslint-disable-next-line no-new-func
      const fn = new Function(...Object.keys(component), `return ${condition}`);
      visibility = fn.apply(null, Object.values(component));
    } catch (err) {
      logger.warn("config visibility condition failed: ", err);
      visibility = false;
    }
  }
  return visibility;
};

// To check if a child element belongs to the parent of a FlatList.
export const isChildOfFlatList = (elementId: string, data: any) => {
  const parentMap = new Map();
  Object.values(data).forEach((element: any) => {
    if (element.fields) {
      element.fields.forEach((field: any) => {
        parentMap.set(field, element.id);
      });
    }
  });
  function checkParent(childId: string) {
    const parentId = parentMap.get(childId);
    if (!parentId) return false;
    const parentElement = data[parentId];
    if (parentElement?.type === "FlatList") return true;
    return checkParent(parentId);
  }
  return checkParent(elementId);
};